import React, { useState, useEffect } from 'react';
import { API, getToken } from './adminApi';

const fmtDate = (d) => d
  ? new Date(d).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
  : '—';

const describeSender = (sender) => {
  if (!sender) return '';
  if (sender.type === 'admin') return `admin: ${sender.adminName || sender.adminId || 'unknown'}`;
  if (sender.type === 'automated') return `automated${sender.automatedRoute ? ` (${sender.automatedRoute})` : ''}`;
  if (sender.type === 'ai_bot') return `AI bot${sender.automatedRoute ? ` (${sender.automatedRoute})` : ''}`;
  return sender.type;
};

const SOURCE_LABELS = { suggestion: '🤝 Interconnecting', campaign: '📣 Campaign', direct: '✉️ Direct email', reply: '↩️ Reply received', reply_sent: '↩️ Reply sent' };

// Self-contained (does its own fetch via adminApi directly rather than
// taking a parent's authedFetch) since EmailManagerTab's and
// GranularInterconnectingEmails's authedFetch helpers use different path
// conventions (one auto-prefixes /admin, the other doesn't) — decoupling
// avoids special-casing per caller.
const EmailHistoryPanel = ({ userId, onClose }) => {
  const [timeline, setTimeline] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = await getToken();
        const res = await fetch(`${API}/admin/emails/history?userId=${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.error || 'Request failed');
        if (!cancelled) setTimeline(json.timeline);
      } catch (err) {
        if (!cancelled) setError(err.message);
      }
    })();
    return () => { cancelled = true; };
  }, [userId]);

  return (
    <div className="as-confirm-overlay" onClick={onClose}>
      <div className="as-confirm-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '520px', maxHeight: '70vh', overflowY: 'auto' }}>
        <h3>Email history</h3>
        {error && <div className="as-error">{error}</div>}
        {!timeline && !error && <div className="as-loading">Loading…</div>}
        {timeline && timeline.length === 0 && <div className="as-empty">No emails sent to or from this person yet.</div>}
        {timeline && timeline.length > 0 && (
          <ul className="as-suggestion-history-list">
            {timeline.map((entry) => (
              <li key={`${entry.source}-${entry._id}`}>
                <strong>{SOURCE_LABELS[entry.source] || entry.source}</strong> — {entry.subject || '(no subject)'}
                <div className="as-card-meta">
                  {fmtDate(entry.sentAt)}
                  {entry.status && ` · ${entry.status}`}
                  {entry.errorMessage && ` · ${entry.errorMessage}`}
                  {entry.sender && ` · ${describeSender(entry.sender)}`}
                  {entry.fromEmail && ` · from ${entry.fromEmail}`}
                </div>
              </li>
            ))}
          </ul>
        )}
        <div className="as-confirm-buttons">
          <button className="as-filter-tab" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default EmailHistoryPanel;
